import { gql } from '@apollo/client';

export interface UserSettingsFragment {
    newThemeEnabled: boolean;
    useCondensedView: boolean;
    useCompactDensityView: boolean;
    layoutsUserSectionExpanded: boolean;
    layoutsAdminTemplateSectionExpanded: boolean;
    layoutsTemplateSectionExpanded: boolean;
    retainedView?: RetainedView;
    retainedGroup?: string;
    zoneMappingConfig?: {
        id: string;
        datasetId: number;
        name: string;
        mappings: { key: string; value: string }[];
        dischMappings?: { key: string; value: string }[];
    };
    defaultCargo?: {
        id: string;
        fullName: string;
    };
}

export enum RetainedView {
    Fixtures = 'FIXTURES',
    Orders = 'ORDERS',
    Multi = 'MULTI',
}

export const USER_SETTINGS_FRAGMENT = gql`
    fragment UserSettingsFragment on UserSettings {
        newThemeEnabled
        useCondensedView
        useCompactDensityView
        layoutsUserSectionExpanded
        layoutsAdminTemplateSectionExpanded
        layoutsTemplateSectionExpanded
        retainedView
        retainedGroup
        zoneMappingConfig {
            id
            datasetId
            name
            mappings {
                key
                value
            }
            dischMappings {
                key
                value
            }
        }
        defaultCargo {
            id
            fullName
        }
    }
`;
